import { safeLocalStorageParse, safeLocalStorageRead, safeLocalStorageWrite } from './localStorage';

const STORAGE_KEY = 'moveo_empty_state_hints_v1';

const MAX_HINTS = 200;

type EmptyStateHints = Record<string, boolean>;

const readHints = (): EmptyStateHints => {
  const parsed = safeLocalStorageParse<EmptyStateHints>(safeLocalStorageRead(STORAGE_KEY));

  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    return {};
  }
  return parsed;
};

export const buildEmptyStateHintKey = (accountSlug: string, scope: string) =>
  `${accountSlug || 'unknown'}:${scope}`;

export const readEmptyStateHint = (key: string): boolean | undefined => {
  const value = readHints()[key];
  return typeof value === 'boolean' ? value : undefined;
};

export const writeEmptyStateHint = (key: string, isEmpty: boolean): void => {
  const hints = readHints();
  if (hints[key] === isEmpty) {
    return;
  }

  delete hints[key];
  const entries = Object.entries({ ...hints, [key]: isEmpty }).slice(-MAX_HINTS);

  safeLocalStorageWrite(STORAGE_KEY, JSON.stringify(Object.fromEntries(entries)));
};
